// Import the necessary libraries

// Function to fetch the VTT file from blob storage
export async function fetchVTTFile(url) {
    if (!url) {
        console.error('No URL provided');
        return null;
    }
    try {
        const response = await fetch(url, { cache: 'no-cache' });
        const vttData = await response.text();
        return vttData;
    } catch (error) {
        console.error('Error fetching VTT file:', error);
        return null;
    }
}
